import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';

import Team from "./Team";
import Locations from "./Locations";
import GeneralSettings from "./GeneralSettings";
import SourcesSettings from "./SourcesSettings";
import SettingsTabs from "../components/SettingsTabs";
import SubNavPanelsWrapper from "../components/SubNavPanelsWrapper";
import LocationDetails from "../containers/LocationDetails";
import UserProfile from "../containers/UserProfile";
import {useSelectedSubNavTab, useIsEdit} from "../utils/CustomHooks";

function Settings(props) {
	const [selectedTab, setSelectedTab] = useState(false);
	const tabs = ["general", "team", "locations", "sources"];

	let {location, updateHeader, resetHeader, showSnackbar, history, setFullScreenClassName,
		bannerHeight, banner, showBanner, updateUser, setBannerClassName, hasNudgeBanner} = props;

	const isEdit = useIsEdit(location);
	const getSelectedTab = useSelectedSubNavTab(location, tabs);
	
	// set selected tab
	useEffect(() => {
		setSelectedTab(getSelectedTab());
	}, [getSelectedTab, setSelectedTab]);

	const tabClicked = (event, tab) => {
		setSelectedTab(tab);
		props.history.push(`/settings/${tab}`);
	};

	return (
		<React.Fragment>
			<SettingsTabs
				isEdit={isEdit}
				selectedTab={selectedTab}
				tabClicked={tabClicked}
				hasNudgeBanner={false}
				setBannerClassName={setBannerClassName} />
			<SubNavPanelsWrapper>
				{selectedTab === tabs[0] ?
					<GeneralSettings
						history={history}
						showSnackbar={showSnackbar}
						updateHeader={updateHeader}
						resetHeader={resetHeader}
						setFullScreenClassName={setFullScreenClassName} /> : null
				}
				{selectedTab === tabs[1] ?
					<Switch>
						<Route
							path="/settings/team/:id"
							render={() => (
								<UserProfile
									{...props}
									showSnackbar={showSnackbar}
									updateHeader={updateHeader}
									resetHeader={resetHeader}
									banner={banner}
									bannerHeight={bannerHeight} />
							)} />

						<Route
							path="/settings/team/add"
							render={() => (
								<UserProfile
									{...props}
									updateUser={updateUser}
									updateHeader={updateHeader}
									resetHeader={resetHeader}
									showSnackbar={showSnackbar}
									banner={banner}
									showBanner={showBanner} />
							)} />

						<Route
							path="/settings/team"
							render={() => (
								<Team
									{...props}
									showSnackbar={showSnackbar}
									updateHeader={updateHeader}
									resetHeader={resetHeader}
									banner={banner}
									bannerHeight={bannerHeight}
									setFullScreenClassName={setFullScreenClassName} />
							)} />
					</Switch> : null
				}
				{selectedTab === tabs[2] ?
					<Switch>
						<Route
							path="/settings/locations/:id"
							render={() => (
								<LocationDetails
									{...props}
									updateHeader={updateHeader}
									resetHeader={resetHeader}
									showSnackbar={showSnackbar}
									banner={banner}
									showBanner={showBanner} />
							)} />

						<Route
							path="/settings/locations/add"
							render={() => (
								<LocationDetails
									{...props}
									updateHeader={updateHeader}
									resetHeader={resetHeader}
									showSnackbar={showSnackbar}
									banner={banner}
									showBanner={showBanner} />
							)} />

						<Route
							path="/settings/locations"
							render={() => (
								<Locations
									{...props}
									showSnackbar={showSnackbar}
									updateHeader={updateHeader}
									resetHeader={resetHeader}
									banner={banner}
									bannerHeight={bannerHeight}
									setFullScreenClassName={setFullScreenClassName} />
							)} />
					</Switch> : null
				}				
			</SubNavPanelsWrapper>
			{selectedTab === tabs[3] ?
					<SourcesSettings
						history={history}
						showSnackbar={showSnackbar}
						updateHeader={updateHeader}
						resetHeader={resetHeader}
						setFullScreenClassName={setFullScreenClassName} /> : null
				}
		</React.Fragment>
	);
}

Settings.propTypes = {
	history: PropTypes.object.isRequired,
	location: PropTypes.object.isRequired,
	updateHeader: PropTypes.func.isRequired,
	resetHeader: PropTypes.func.isRequired,
	showSnackbar: PropTypes.func.isRequired,
	banner: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
	bannerHeight: PropTypes.number,
	showBanner: PropTypes.func.isRequired,
	setBannerClassName: PropTypes.func.isRequired,
	updateUser: PropTypes.func.isRequired,
	hasNudgeBanner: PropTypes.bool,
	setFullScreenClassName: PropTypes.func
};

export default Settings;